<template>
  <div class="primaryschool-container">
    <div class="primaryschool-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/primaryschool-banner.png"
        alt=""
      />
      <div class="interact-container-banner-box">
        <div class="interact-container-banner-box-content">
          <h2>中小学图书馆特色解决方案</h2>
          <p>
            中小学整体解决方案，基于RFID射频技术结合物联网、大数据、移动互联网技术、智能化设备
          </p>
          <p>
            创造性设计RFID图书、泛在图书馆、智慧阅读空间等应用场景，并辅助特色软件应用平台
          </p>
          <p>
            方案帮助图书馆提升服务效率和读者获取图书资源的便利性
          </p>
        </div>
      </div>
    </div>
    <!-- 整体方案 -->
    <div class="primaryschool-container-overall">
      <h2 class="primaryschool-container-overall-title title-common">
        整体方案
      </h2>
      <!-- https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-bubble.png -->
      <div class="primaryschool-container-overall-content">
        <div class="primaryschool-container-overall-content-tab">
          <ul>
            <li
              v-for="(item, i) in tabOptions"
              :key="i"
              @click="handleChange(i)"
              :class="{ tabActive: current == i }"
            >
              {{ item.msg }}
            </li>
          </ul>
        </div>
        <div class="primaryschool-container-overall-content-list">
          <ol>
            <li v-for="(item, i) in solutionList" :key="i">
              <img :src="item.pic" alt="" />
              <h4>{{ item.title }}</h4>
              <div class="line" v-if="i + 1 !== solutionList.length"></div>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <!-- 泛在阅读空间 -->
    <div class="primaryschool-container-readspace">
      <h2 class="primaryschool-container-readspace-title title-common">
        泛在阅读空间
      </h2>
      <div class="primaryschool-container-readspace-subtitle">
        <p>
          泛在图书馆通过阅读空间和服务的泛在化，使读者不受时间、空间、地域的限制
        </p>
        <p>可以随时随地接触到图书馆的资源，享受到图书馆的服务</p>
      </div>
      <div class="primaryschool-container-readspace-content">
        <div class="primaryschool-container-readspace-content-circle">
          <div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-item1.png"
              alt=""
            />
            <p>操场图书馆</p>
          </div>
          <div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-item2.png"
              alt=""
            />
            <p>班级阅读角</p>
          </div>
          <div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-item3.png"
              alt=""
            />
            <p>走廊阅读角</p>
          </div>
          <div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-item4.png"
              alt=""
            />
            <p>校门自助借还室</p>
          </div>
          <div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-item5.png"
              alt=""
            />
            <p>阅读文化墙</p>
          </div>
          <div class="circle-woman">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primaryschool/primary-circle-woman.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 智慧阅读空间 -->
    <div class="primaryschool-container-wisdom">
      <h2 class="primaryschool-container-wisdom-title title-common">
        智慧阅读空间
      </h2>
      <div class="primaryschool-container-wisdom-content">
        <div class="primaryschool-container-wisdom-content-top">
          <div class="primaryschool-container-wisdom-content-top-left">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/primary/primary-index-round.png"
              alt=""
            />
          </div>
          <div class="primaryschool-container-wisdom-content-top-right">
            <p>
              智慧阅读空间打破了以纸质作为媒介的传统阅读模式
            </p>
            <p>
              利用智能化设备和互动媒介等技术
            </p>
            <p>建设新型的数字化、智慧化的阅读空间</p>
            <p>智慧阅读空间不仅能够满足读者的基本阅读需求</p>
            <p>还能依托大数据开展智能化的“可知、可导、可管”的个性化阅读服务</p>
          </div>
        </div>
        <div class="primaryschool-container-wisdom-content-bottom">
          <ul>
            <li v-for="(item, i) in libList" :key="i">
              <img :src="item.pic" alt="" />
              <i>{{ item.title }}</i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- VR学习体验系统 -->
    <div class="primaryschool-container-VR">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/primary/primary-index-VR.png"
        alt=""
      />
    </div>
    <div class="primaryschool-container-AR">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/primary/primary-index-AR.png"
        alt=""
      />
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      current: 0,
      tabOptions: [
        {
          msg: "RFID图书馆",
        },
        {
          msg: "泛在图书馆",
        },
        {
          msg: "智慧阅读空间",
        },
        {
          msg: "软件应用平台",
        },
      ],
      solutionList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item1.png",
          title: "智能书架",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item2.png",
          title: "智能盘点设备",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item3.png",
          title: "馆员工作站",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item4.png",
          title: "安全防盗门禁",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item5.png",
          title: "自助借还办证一体机",
        },
      ],
      libList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-wisdom-item1.png",
          title: "数字朗读空间",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-wisdom-item2.png",
          title: "数字阅读空间",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-wisdom-item3.png",
          title: "数字体验空间",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/primary/primary-wisdom-item4.png",
          title: "VR/AR学习空间",
        },
      ],
    };
  },
  methods: {
    handleChange(i) {
      this.current = i;
      switch (i) {
        case 0:
          this.solutionList = [
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item1.png",
              title: "智能书架",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item2.png",
              title: "智能盘点设备",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item3.png",
              title: "馆员工作站",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item4.png",
              title: "安全防盗门禁",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item5.png",
              title: "自助借还办证一体机",
            },
          ];
          break;
        case 1:
          this.solutionList = [
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item6.png",
              title: "阅读文化墙校园",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item7.png",
              title: "校门自助借还室",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item8.png",
              title: "操场微型图书馆",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item9.png",
              title: "走廊阅读角",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item10.png",
              title: "班级阅读角",
            },
          ];
          break;
        case 2:
          this.solutionList = [
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item11.png",
              title: "数字体验空间",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item12.png",
              title: "AR/VR学习空间",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item13.png",
              title: "数字阅读空间",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item14.png",
              title: "数字朗读空间",
            },
          ];
          break;
        case 3:
          this.solutionList = [
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item15.png",
              title: "云图书管理系统",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item16.png",
              title: "阅读大数据平台",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item17.png",
              title: "图书评价系统",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item18.png",
              title: "阅读能力测评系统",
            },
            {
              pic:
                "https://image.bookgo.com.cn/bgOfficial/primary/primary-index-item19.png",
              title: "线上家长互动平台",
            },
          ];
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libPrimaryschool.scss";
</style>
